import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Articles() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchArticles() {
            try {
                const res = await fetch('/.netlify/functions/fetch-articles');
                const data = await res.json();
                setArticles(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
        fetchArticles();
    }, []);

    if (loading) return <div>Loading articles...</div>;
    if (articles.length === 0) return <div>No articles found.</div>;

    return (
        <div>
            <h1>Articles</h1>
            <ul>
                {articles.map(({ id, title, slug }) => (
                    <li key={id}>
                        <Link to={`/articles/${slug}`}>{title}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
